import { useDeleteMappingAssetTagsMutation } from "graphqlBase/MappingAssetTag/__generated__/deleteMappingAssetTags";
import { MappingAssetTag } from "..";

const useDeleteAssetTags = ({
  selectedAssetIds,
  afterMutation,
}: {
  afterMutation?: () => void;
  selectedAssetIds: string[] | undefined;
}) => {
  const [deleteMappingAssetTagsMutation, { loading }] = useDeleteMappingAssetTagsMutation();

  const handleDeleteAssetTags = async ({
    mappingAssetTags,
    ids,
  }: {
    ids: string[];
    mappingAssetTags: MappingAssetTag[];
  }) => {
    if (!selectedAssetIds?.length) return;
    const deleteMappingAssetTags = ids.flatMap((id) =>
      selectedAssetIds
        .map((currId) => {
          const index = mappingAssetTags.findIndex((entry) => entry.assetId === currId && entry.assetTagId === id);
          if (index !== -1)
            return {
              mappingAssetTagId: mappingAssetTags[index].id,
              assetTagId: mappingAssetTags[index].assetTagId,
            };
        })
        .filter(Boolean)
    );

    if (deleteMappingAssetTags.length > 0) {
      await deleteMappingAssetTagsMutation({
        variables: { ids: deleteMappingAssetTags.map((curr) => curr?.mappingAssetTagId) as string[] },
      });
      if (afterMutation) {
        afterMutation();
      }
    }
  };

  return {
    deleteAssetTagsLoading: loading,
    handleDeleteAssetTags,
  };
};

export default useDeleteAssetTags;
